export default {
  production: '646362ceae93250e8718de1e',
  development: '64635aab1c3def25e4b41032',
};
